
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IdleTimeoutService } from 'src/app/core/services/idle-timeout.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';

@Component({
  selector: 'app-con-app-idle-timeout-modal',
  templateUrl: './con-app-idle-timeout-modal.component.html',
  styleUrls: ['./con-app-idle-timeout-modal.component.scss']
})
export class ConAppIdleTimeoutModalComponent implements OnInit, OnDestroy {

  alertMessage: string;
  timeRemaining : number = 10;
  showRelogin : boolean =  false;

  constructor(
    private readonly dialogRef: MatDialogRef<ConAppIdleTimeoutModalComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private readonly idleService: IdleTimeoutService,
    private readonly sharedDataService: SharedDataService) { 

    if(data.expired) {
      this.timeRemaining = 0;
    }
    this.sharedDataService.sessionExpiredAlert=true;

  }
  ngOnDestroy(): void {
    this.sharedDataService.sessionExpiredAlert = false;
  }

  private setAlertMessage(minutes: number) {
      this.timeRemaining = Number.parseInt(minutes?.toString());
      if (this.timeRemaining <= 0 ) {
        this.alertMessage = `Your Console session expired.`;
        this.showRelogin = true;
      } else {
        let remainingTime = Number.parseInt(this.timeRemaining?.toString());
        this.alertMessage = `Your Console session will expire in ${remainingTime} minutes.`;
        this.showRelogin = false;
      }
  }

  ngOnInit(): void {
    this.setAlertMessage(this.timeRemaining);
    this.idleService.sessionExpireMinRemaining.subscribe(minutes => {
      this.setAlertMessage(minutes);
    });
  }

  logout() {
    this.dialogRef.close('logout');
  }

  extend() {
    this.sharedDataService.sessionExpiredAlert = false;
    this.dialogRef.close('extend');
  }

}